
export class AppError extends Error {
  internalError?: Error;
  statusCode?: number;

  constructor(message: string, internalError: any) {
    super(message);
    this.internalError = internalError;
    // Object.setPrototypeOf(this, AppError.prototype); // for instanceof to work
  }
}
